// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/Ellipse 9 (3).png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
  --primary-bg-white: #ffffffad;
}

.about-us-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
  padding: 5rem 1rem;
}

.about-us {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 2rem;
  border-radius: 20px;
  height: auto;
  max-width: 90%;
  margin: 0 auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.449);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(10px);
  transition: transform 0.5s ease, opacity 0.5s ease;
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 1s forwards ease-in-out;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.about-us-content {
  flex: 1 1 45%;
  max-width: 100%;
  padding: 3rem 1rem;
}

.about-us-title {
  font-size: 2.5rem;
  color: var(--primary-blue);
}

.about-us-subtitle {
  font-size: 1.8rem;
  color: var(--primary-black2);
  margin-top: 1rem;
}

.about-us-subtitle .highlight {
  color: var(--primary-blue);
  font-weight: bold;
}

.about-us-description1,
.about-us-description {
  margin-top: 1rem;
  color: var(--primary-grey);
  font-size: 1rem;
  line-height: 1.5;
  text-align: justify;
  font-weight: 500;
}

.about-us-button {
  gap: 10px;
  border: none;
  display: flex;
  overflow: none;
  font-size: 18px;
  cursor: pointer;
  margin-top: 20px;
  align-items: center;
  border-radius: 12px;
  padding: 15px 2.5rem;
  transition: 0.3s linear;
  color: var(--primary-white);
  background-color: var(--primary-blue);
}

.about-us-button:hover {
  transform: translateY(-5px);
  background-color: #555ae6;
  box-shadow: 1px 1px 10px #6d72f6;
}

.about-us-image {
  flex: 1 1 45%;
  max-width: 100%;
  position: relative;
  padding: 0 1rem;
  text-align: center;
}

.image-main {
  width: 100%;
  border-radius: 20px;
  display: block;
  margin: 0 auto;
}

.image-overlay {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--primary-blue);
  color: var(--primary-white);
  padding: 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.image-overlay p {
  margin: 0.5rem 0;
}

/* Responsive Styles */
@media (max-width: 1024px) {
  .about-us {
    flex-direction: column;
    padding: 1.5rem;
  }

  .about-us-content {
    text-align: center;
  }

  .about-us-title {
    font-size: 2rem;
  }

  .about-us-subtitle {
    font-size: 1.5rem;
  }

  .about-us-description1,
  .about-us-description {
    font-size: 0.9rem;
  }

  .about-us-button {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .about-us {
    padding: 0 1rem;
  }

  .about-us-title {
    font-size: 1.8rem;
  }

  .about-us-subtitle {
    font-size: 1.3rem;
  }

  .about-us-description1,
  .about-us-description {
    font-size: 0.85rem;
  }

  .about-us-button {
    font-size: 0.85rem;
  }

  .image-overlay {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .about-us-wrapper {
    padding: 2rem 1rem;
  }

  .about-us-title {
    font-size: 1.5rem;
  }

  .about-us-subtitle {
    font-size: 1.2rem;
  }

  .about-us-description1,
  .about-us-description {
    font-size: 0.75rem;
  }

  .about-us-button {
    font-size: 0.75rem;
  }

  .image-overlay {
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/AboutUs/AboutUs.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yDAAgD;EAChD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yCAAyC;EACzC,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;EACnC,kDAAkD;EAClD,UAAU;EACV,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n  --primary-bg-white: #ffffffad;\n}\n\n.about-us-wrapper {\n  background-image: url('./img/Ellipse 9 (3).png');\n  background-size: contain;\n  background-position: left center;\n  background-repeat: no-repeat;\n  padding: 5rem 1rem;\n}\n\n.about-us {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 0 2rem;\n  border-radius: 20px;\n  height: auto;\n  max-width: 90%;\n  margin: 0 auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  background-color: rgba(255, 255, 255, 0.449);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(10px);\n  transition: transform 0.5s ease, opacity 0.5s ease;\n  opacity: 0;\n  transform: translateY(30px);\n  animation: fadeIn 1s forwards ease-in-out;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.about-us-content {\n  flex: 1 1 45%;\n  max-width: 100%;\n  padding: 3rem 1rem;\n}\n\n.about-us-title {\n  font-size: 2.5rem;\n  color: var(--primary-blue);\n}\n\n.about-us-subtitle {\n  font-size: 1.8rem;\n  color: var(--primary-black2);\n  margin-top: 1rem;\n}\n\n.about-us-subtitle .highlight {\n  color: var(--primary-blue);\n  font-weight: bold;\n}\n\n.about-us-description1,\n.about-us-description {\n  margin-top: 1rem;\n  color: var(--primary-grey);\n  font-size: 1rem;\n  line-height: 1.5;\n  text-align: justify;\n  font-weight: 500;\n}\n\n.about-us-button {\n  gap: 10px;\n  border: none;\n  display: flex;\n  overflow: none;\n  font-size: 18px;\n  cursor: pointer;\n  margin-top: 20px;\n  align-items: center;\n  border-radius: 12px;\n  padding: 15px 2.5rem;\n  transition: 0.3s linear;\n  color: var(--primary-white);\n  background-color: var(--primary-blue);\n}\n\n.about-us-button:hover {\n  transform: translateY(-5px);\n  background-color: #555ae6;\n  box-shadow: 1px 1px 10px #6d72f6;\n}\n\n.about-us-image {\n  flex: 1 1 45%;\n  max-width: 100%;\n  position: relative;\n  padding: 0 1rem;\n  text-align: center;\n}\n\n.image-main {\n  width: 100%;\n  border-radius: 20px;\n  display: block;\n  margin: 0 auto;\n}\n\n.image-overlay {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--primary-blue);\n  color: var(--primary-white);\n  padding: 1rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.image-overlay p {\n  margin: 0.5rem 0;\n}\n\n/* Responsive Styles */\n@media (max-width: 1024px) {\n  .about-us {\n    flex-direction: column;\n    padding: 1.5rem;\n  }\n\n  .about-us-content {\n    text-align: center;\n  }\n\n  .about-us-title {\n    font-size: 2rem;\n  }\n\n  .about-us-subtitle {\n    font-size: 1.5rem;\n  }\n\n  .about-us-description1,\n  .about-us-description {\n    font-size: 0.9rem;\n  }\n\n  .about-us-button {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-us {\n    padding: 0 1rem;\n  }\n\n  .about-us-title {\n    font-size: 1.8rem;\n  }\n\n  .about-us-subtitle {\n    font-size: 1.3rem;\n  }\n\n  .about-us-description1,\n  .about-us-description {\n    font-size: 0.85rem;\n  }\n\n  .about-us-button {\n    font-size: 0.85rem;\n  }\n\n  .image-overlay {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-us-wrapper {\n    padding: 2rem 1rem;\n  }\n\n  .about-us-title {\n    font-size: 1.5rem;\n  }\n\n  .about-us-subtitle {\n    font-size: 1.2rem;\n  }\n\n  .about-us-description1,\n  .about-us-description {\n    font-size: 0.75rem;\n  }\n\n  .about-us-button {\n    font-size: 0.75rem;\n  }\n\n  .image-overlay {\n    font-size: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
